var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84003 8.04C3.84003 6.36105 5.20108 5 6.88003 5H27.6533V20.2H3.84003V8.04Z",
    fill: "url(#paint0_linear_887_4811)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21H1V24H31V21Z",
    fill: "url(#paint1_linear_887_4811)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19C3 17.8954 3.89543 17 5 17H8C9.10457 17 10 17.8954 10 19V21H3V19Z",
    fill: "#FAB215"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19C12 17.8954 12.8954 17 14 17H17C18.1046 17 19 17.8954 19 19V21H12V19Z",
    fill: "#FAB215"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19C21 17.8954 21.8954 17 23 17H26C27.1046 17 28 17.8954 28 19V21H21V19Z",
    fill: "#FAB215"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4811",
    x1: 7.38669,
    y1: 6.01333,
    x2: 17.52,
    y2: 19.0178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_887_4811",
    x1: 7,
    y1: 21.2222,
    x2: 7,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.1d243f8da43cea0f8265eccd46241ce1.svg";
export { ForwardRef as ReactComponent };